module.exports = __webpack_public_path__ + "static/media/microphone.9103f567.svg";